import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { auth } from '../../../config/Fire';
import { setLogout } from '../../../actions/user';
import { getUser, getCompanies } from '../../../reducers';
import * as Constants from '../../../constants';
import MainMenuRegister from '../../components/MainMenuRegister';
import Users from '../Users';
import Registers from '../Registers';
import Projects from '../Projects';
import MedicalLicenses from '../MedicalLicenses';
import { getAllCompanies } from '../../../actions/company/getAllCompanies';
import LoadingPage from '../../components/LoadingPage';

const { Content, Footer } = Layout;

class MainRegister extends Component {
    state = {
        itemSelected: Constants.MenuRegister.USERS
    }

    onItemClick = ({ itemClickType }) => {
        switch (itemClickType) {
            case Constants.MenuRegister.USERS:
                this.props.history.push(`/`);
                break;
            case Constants.MenuRegister.LOGOUT:
                this.props.setLogout();
                auth.signOut();
                this.props.history.push(`/`);
                break;
            default:
                this.props.history.push(`/${itemClickType}`);
                break;
        }
        this.setState({ itemSelected: itemClickType });
    }

    handlerGetInfo = () => {
        this.props.getAllCompanies()
        return <LoadingPage />
    }

    render() {
        const { location, companies } = this.props;
        return (
            <Layout style={{ minHeight: '100vh' }}>
                {
                    companies ?
                        <div>
                            <MainMenuRegister onItemClick={this.onItemClick} itemSelected={location.pathname} />
                            <Layout>
                                <Content style={{ margin: '0' }}>
                                    <div style={{ margin: '0', padding: 16, background: '#fff', minHeight: '90vh' }}>
                                        <Route exact path={`/${Constants.MenuRegister.REGISTERS}`} component={Registers} />
                                        <Route exact path={`/${Constants.MenuRegister.PROJECTS}`} component={Projects} />
                                        <Route exact path={`/${Constants.MenuRegister.MEDICAL_LICENSES}`} component={MedicalLicenses} />
                                        <Route exact path="/" component={Users} />
                                    </div>
                                </Content>
                                <Footer style={{ textAlign: 'center' }}>
                                    Copyright ©2020 <a href="https://www.autosolve.com.ar/" target="_blank" rel="noopener noreferrer">AutoSolve</a>
                                </Footer>
                            </Layout>
                        </div>
                        :
                        this.handlerGetInfo()
                }
            </Layout>
        );
    }
}

MainRegister.propTypes = {
    setLogout: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setLogout: value => dispatch(setLogout(value)),
    getAllCompanies: value => dispatch(getAllCompanies(value)),
});

const mapStateToProps = state => ({
    user: getUser(state),
    companies: getCompanies(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(MainRegister));

